// extracted by mini-css-extract-plugin
export default {"loader":"MyLoader_loader__LY9Bh","rotate":"MyLoader_rotate__UASb4"};